module.exports = __webpack_public_path__ + "img/028.042ef2e7.png";